import { urlForImage } from '@/sanity/lib/image'

export function generateArticleSchema(post) {
  const baseUrl = 'https://www.venturawebdesign.com'
  
  return {
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline: post.title,
    description: post.excerpt,
    image: post.mainImage ? urlForImage(post.mainImage) : `${baseUrl}/brand/meta/ventura-og.png`,
    author: {
      '@type': 'Person',
      name: post.author
    },
    publisher: {
      '@type': 'Organization',
      name: 'Ventura Web Design',
      logo: {
        '@type': 'ImageObject',
        url: `${baseUrl}/brand/logos/ventura-logo.png`
      }
    },
    datePublished: post.publishedAt,
    dateModified: post.lastModified || post.publishedAt, // Always fall back to publishedAt if no lastModified
    mainEntityOfPage: {
      '@type': 'WebPage',
      '@id': `${baseUrl}/resources/${post.slug.current}`
    },
    articleSection: post.categories?.length > 0 ? post.categories[0].title : 'Web Design & Marketing'
  }
}
